export default __webpack_public_path__ + "static/media/archived.d08ef7ee.svg";